module.exports = __webpack_public_path__ + "img/Endesa_80X30.916c7795.png";